// extracted by mini-css-extract-plugin
module.exports = {"container":"_2aeZ7f0Ysf91-r9FXjUS1s","visible":"_310TXIVaRuTjpjyQbQbF9b","cancelBtn":"_2qbOxuHvdxfgvs7mM-rve8","icon":"_3cxCiNFJrBNFs9jk6Rh3SN","saveBtn":"_28eDWEtuel88aASuQjEV9u"};